import type { SlotProps as MuiSlotProps, SnackbarProps } from '@mui/material';
import type { FC } from 'react';
import type { ThemeSx, ToastMessage } from './useToast';

import * as React from 'react';
import { Alert, Snackbar } from '@mui/material';

export type ToastStyle = Omit<
  SnackbarProps,
  'TransitionProps' | 'onClose' | 'open' | 'children' | 'message'
>;

export type ToastProps = {
  message: ToastMessage;
  onExited: () => void;
  snackbarSx?: ThemeSx;
} & ToastStyle;

type SlotProps = MuiSlotProps<'div', any, any>;

// https://mui.com/material-ui/react-snackbar/#consecutive-snackbars
export const Toast: FC<ToastProps> = ({ message, onExited, autoHideDuration, ...props }) => {
  const {
    vertical = 'bottom',
    horizontal = 'center',
    sx = {},
    snackbarSx = {},
  } = message?.toastConfig || {};
  const [open, setOpen] = React.useState(true);
  const { sx: propsSx = {}, ...rest } = props;
  const mergedSx = { ...propsSx, ...(sx as ThemeSx) } as SlotProps;

  const handleClose = (_event: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  return (
    <Snackbar
      key={message.key}
      open={open}
      onClose={handleClose}
      data-testid="toast-notification"
      TransitionProps={{ onExited }}
      anchorOrigin={{ vertical, horizontal }}
      autoHideDuration={autoHideDuration ?? 5000}
      sx={snackbarSx}
      {...rest}
    >
      <Alert severity={message.severity} onClose={handleClose} sx={mergedSx}>
        {message.message}
      </Alert>
    </Snackbar>
  );
};
